// extracted by mini-css-extract-plugin
module.exports = {"featuresList":"features_list__featuresList__bCAZo display__display_flex__hfG-Z flex__direction_col__MJw-a"};